import { useState } from 'react';
import { usePortfolio } from '../context/PortfolioContext';
import { useModals } from '../context/ModalContext';
import { brokerBadgeClass, brokerLabel } from '../utils/broker';
import toast from 'react-hot-toast';

function TradesPage() {
  const { trades, isLoading, deleteTrade } = usePortfolio();
  const { openTrade } = useModals();
  const [sortKey, setSortKey] = useState('date');
  const [sortDir, setSortDir] = useState('desc');

  const sortedTrades = [...(trades || [])].sort((a, b) => {
    const aVal = a[sortKey] || '';
    const bVal = b[sortKey] || '';
    if (sortDir === 'asc') {
      return aVal > bVal ? 1 : -1;
    }
    return aVal < bVal ? 1 : -1;
  });

  const handleSort = (key) => {
    if (sortKey === key) {
      setSortDir(sortDir === 'asc' ? 'desc' : 'asc');
    } else {
      setSortKey(key);
      setSortDir('desc');
    }
  };

  const handleDelete = async (id) => {
    if (!confirm('Are you sure you want to delete this trade?')) return;
    const success = await deleteTrade(id);
    if (success) {
      toast.success('Trade deleted');
    }
  };

  const formatCurrency = (value) => {
    if (!value) return '-';
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 2,
    }).format(value);
  };

  const formatNumber = (value, decimals = 2) => {
    if (!value) return '-';
    return Number(value).toFixed(decimals);
  };

  if (isLoading && !trades?.length) {
    return <div className="loading-screen"><div className="loading-spinner"></div></div>;
  }

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Trade History</h1>
      </div>

      <div className="data-table-container">
        <div className="data-table-header">
          <span className="data-table-title">Transactions</span>
          <span className="data-table-badge">{trades?.length || 0} transactions</span>
        </div>
        <div className="data-table-wrapper">
          <table className="data-table">
            <thead>
              <tr>
                <th onClick={() => handleSort('date')}>Date {sortKey === 'date' && (sortDir === 'asc' ? '↑' : '↓')}</th>
                <th onClick={() => handleSort('ticker')}>Ticker {sortKey === 'ticker' && (sortDir === 'asc' ? '↑' : '↓')}</th>
                <th className="center" onClick={() => handleSort('side')}>Side {sortKey === 'side' && (sortDir === 'asc' ? '↑' : '↓')}</th>
                <th className="num" onClick={() => handleSort('quantity')}>Quantity {sortKey === 'quantity' && (sortDir === 'asc' ? '↑' : '↓')}</th>
                <th className="num">Price</th>
                <th className="num">Gross (Local)</th>
                <th className="num">Amount GBP</th>
                <th className="center">Currency</th>
                <th>Broker</th>
                <th className="num">Commission</th>
                <th className="center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {sortedTrades.map(trade => (
                <tr key={trade.id}>
                  <td>{trade.date}</td>
                  <td>{trade.ticker?.toUpperCase()}</td>
                  <td className="center">
                    <span style={{ 
                      color: trade.side === 'BUY' ? 'var(--green)' : 'var(--red)',
                      fontWeight: 600,
                    }}>
                      {trade.side}
                    </span>
                  </td>
                  <td className="num">{formatNumber(trade.quantity)}</td>
                  <td className="num">{formatNumber(trade.price)} {trade.currency}</td>
                  <td className="num">{formatNumber(trade.quantity * trade.price)} {trade.currency}</td>
                  <td className="num">{formatCurrency(trade.amount_gbp)}</td>
                  <td className="center">{trade.currency}</td>
                  <td>
                    <span className={brokerBadgeClass(trade.broker)}>
                      {brokerLabel(trade.broker)}
                    </span>
                  </td>
                  <td className="num">{formatCurrency(trade.commission_gbp)}</td>
                  <td className="center">
                    <div className="table-actions">
                      <button 
                        className="btn btn-secondary btn-sm"
                        onClick={() => openTrade(trade)}
                      >
                        Edit
                      </button>
                      <button 
                        className="btn btn-danger btn-sm"
                        onClick={() => handleDelete(trade.id)}
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default TradesPage;
